import {GameBoard, GameConfig, GameData, GamePlay, GamePlayKey, GameSetup} from "../types";
import {v4 as uuid} from "uuid";
import {md5_uuid} from "../../../shared/md5";

export class DubbleupLayout {

  constructor(readonly level: DubbleupDifficultyLevel) {
  }
}

export class DubbleupDifficultyLevel {

  static readonly VALUES = new Array<DubbleupDifficultyLevel>(4);
  static readonly EASY = DubbleupDifficultyLevel.VALUES[0] = new DubbleupDifficultyLevel("easy", "Easy", "Easy desc", Math.pow(2, 8));
  static readonly MEDIUM = DubbleupDifficultyLevel.VALUES[1] = new DubbleupDifficultyLevel("medium", "Medium", "Medium desc", Math.pow(2, 10));
  static readonly HARD = DubbleupDifficultyLevel.VALUES[2] = new DubbleupDifficultyLevel("hard", "Hard", "Hard desc", Math.pow(2, 12));
  static readonly VERY_HARD = DubbleupDifficultyLevel.VALUES[3] = new DubbleupDifficultyLevel("very_hard", "Very Hard", "Very Hard desc", Math.pow(2, 13));

  constructor(readonly name: string, readonly text: string, readonly description: string, readonly maxTileValue: number) {
  }
}

export class DubbleupGameConfig extends GameConfig {

  constructor(readonly level: DubbleupDifficultyLevel) {
    super();
  }
}

export class DubbleupGameSetup extends GameSetup {

  constructor(key: GamePlayKey) {
    super(key);
  }
}

export type TileData = {
  id: string,
  value: number,
}

export function createBoardTiles(): TileData[][] {
  const tiles: TileData[][] = [];
  for (let i = 0; i < 4; i++) {
    const row: TileData[] = [];
    for (let j = 0; j < 4; j++) {
      row.push({id: md5_uuid(), value: 0});
    }
    tiles.push(row);
  }
  const initIndices: number[] = [];
  for (let i = 0; i < 4 * 4; i++) {
    initIndices.push(i);
  }
  const i1 = initIndices.splice(Math.floor(initIndices.length * Math.random()), 1)[0];
  const i2 = initIndices.splice(Math.floor(initIndices.length * Math.random()), 1)[0];
  tiles[Math.floor(i1 / 4)][i1 % 4] = {id: md5_uuid(), value: 2};
  tiles[Math.floor(i2 / 4)][i2 % 4] = {id: md5_uuid(), value: 2};
  return tiles;
}

export class DubbleupGameData extends GameData<DubbleupGameBoard> {

  static async create(config: DubbleupGameConfig): Promise<DubbleupGameData> {
    const loader = new DubbleupGamesLoader();
    const layout = await loader.getRandomGame(config.level);
    const setup = new DubbleupGameSetup(new GamePlayKey("dubbleup", uuid()));
    const now = Date.now();
    return new DubbleupGameData(new GamePlay(setup, now, 0, 0, 0, new DubbleupGameBoard(config.level, layout, createBoardTiles())));
  }
}

export class DubbleupGamesLoader {

  async getRandomGame(level: DubbleupDifficultyLevel): Promise<DubbleupLayout> {
    return new DubbleupLayout(level);
  }
}

export class DubbleupGameBoard extends GameBoard {

  constructor(readonly level: DubbleupDifficultyLevel, readonly layout: DubbleupLayout, readonly tiles: TileData[][]) {
    super();
  }

  getPoints(moves: number): number {
    return Math.max(0, (25 - moves) * 50);
  }

  toJSON(): any {
    return this;
  }
}